












import CompanyTable from "@/components/company/CompanyTable.vue";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { ICompany } from "@/models/company.entity";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { CompanyTable },
  filters: {}
})
class CompanySelectionTable extends Vue {
  @Prop({ default: null })
  value!: ICompany | null;

  @Prop()
  filter?: CompanyServiceEnum | null;

  get selected(): ICompany[] {
    if (this.value) {
      return [this.value];
    }
    return [];
  }

  set selected(value: ICompany[]) {
    const selected = value.length > 0 ? value[0] : null;
    this.$emit("input", selected);
  }

  get partner() {
    return PartnerModule.partner;
  }

  get partnerId() {
    return this.partner.id;
  }

  get filters() {
    if (this.filter) {
      return [new PageFilterElement({ key: "services", operation: PageFilterOperationEnum.EQUAL, value: this.filter })];
    }
    return [];
  }
}

export default CompanySelectionTable;
